export default __webpack_public_path__ + "static/media/Administrator_Role.1911f683.svg";